import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ProjectForm } from '@/features/projects/project-form';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/projects/new')({ component: NewProjectRoute });

function NewProjectRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="projects"
      crumbs={[{ label: t('nav.items.projects') }, { label: t('projects.newTitle') }]}
    >
      <ProjectForm tenantId={tenant} />
    </ConsoleShell>
  );
}
